import { Location } from "@angular/common";
import { Component, OnInit, computed, inject, signal } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";

import { EstadoMantenimientoService } from "../estado-mantenimiento.service";
import { MENSAJE_POR_OMISION, textoHasta } from "../reglas";

/**
 * El aviso de un módulo en mantenimiento (16/10/2026): a esta página manda
 * el guardia de rutas cuando alguien quiere entrar a algo que está en
 * mantenimiento (?m=<clave>). Si ya terminó, lo dice y ofrece volver.
 */
@Component({
  selector: "app-modulo-en-mantenimiento",
  imports: [RouterLink],
  templateUrl: "./modulo-en-mantenimiento.component.html",
  styleUrl: "./modulo-en-mantenimiento.component.css",
})
export class ModuloEnMantenimientoComponent implements OnInit {
  private readonly estado = inject(EstadoMantenimientoService);
  private readonly ruta = inject(ActivatedRoute);
  private readonly location = inject(Location);

  private readonly clave = signal("");
  readonly cargando = signal(true);

  /** El módulo de la URL, si sigue en mantenimiento. */
  readonly modulo = computed(() => (this.clave() ? this.estado.porClave(this.clave()) : undefined));
  readonly mensaje = computed(() => (this.modulo()?.mensaje || "").trim() || MENSAJE_POR_OMISION);
  readonly cuando = computed(() => textoHasta(this.modulo()?.hasta));

  ngOnInit(): void {
    this.clave.set(this.ruta.snapshot.queryParamMap.get("m") || "");
    this.estado.refrescar().subscribe(() => this.cargando.set(false));
  }

  regresar(): void {
    this.location.back();
  }
}
